import { Box, makeStyles, Typography, useTheme } from "@material-ui/core";
import React from "react";
import PriceCost from "./PriceCost";
import PropTypes from "prop-types";
import { Skeleton } from "@material-ui/lab";
import { useCurrency, useI18N } from "../../../common/common";
import { useBreakpoints } from "../../../hooks";

const useStyles = makeStyles((theme) => ({
    mb: {
        marginBottom: theme.spacing(2)
    },
    textLineThrough: {
        textDecoration: "line-through"
    },
    discountTotal: {
        marginLeft: theme.spacing(0.5),
        fontWeight: "600"
    }
}));

// eslint-disable-next-line no-unused-vars
const PriceCostList = ({ items, currency, total, totalDescription, originalTotal, inDirectSalesOrderView, pointsPromotionElement, loyaltyDiscountElement }) => {
    const theme = useTheme();
    const { formatCurrency } = useCurrency();
    const { i18n } = useI18N();
    const classes = useStyles();
    const { isExtraSmallScreen } = useBreakpoints();

    return (
        <Box
            p={2}
            borderRadius={`${theme.spacing(1)}px`}
            bgcolor={theme.palette.secondary[50]}
        >
            {/* Costs */}
            <Box
                p={2}
                bgcolor={theme.palette.background.default}
            >
                <Typography
                    variant="subtitle1"
                    className={classes.mb}
                >
                    {i18n("common.label.your_selection")}
                </Typography>

                {items?.map((item, index) => (
                    <PriceCost
                        key={item.title?.toLowerCase()?.replace(" ", "_")}
                        title={item.title}
                        description={item.description}
                        price={item.price}
                        discountPrice={item?.discountPrice}
                        currency={currency}
                        divider={items?.length !== index + 1}
                        discounts={item.discounts}
                    />
                ))}

                {React.isValidElement(pointsPromotionElement) && pointsPromotionElement}
            </Box>

            <Box
                pt={3}
                pb={1}

            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    px={(isExtraSmallScreen() || inDirectSalesOrderView) ? 2 : 0}
                >
                    <Typography variant="subtitle1">
                        {i18n("common.label.total")}
                    </Typography>

                    {(total && originalTotal) ? (
                        <Box
                            display="flex"
                            alignItems="baseline"
                        >
                            <Typography
                                component="span"
                                variant="body1"
                            >
                                {total !== originalTotal && (
                                    <span className={classes.textLineThrough}>
                                        {formatCurrency(currency, originalTotal)}
                                    </span>
                                )}
                                <span className={classes.discountTotal}>{formatCurrency(currency, total)}</span>
                            </Typography>
                        </Box>
                    ) : <Skeleton width={120} />
                    }
                </Box>

                {/*Hotfix for NCE-5478 Direct sales checkout page - loyalty discount not displayed*/}
                {/*Remember to remove the es-lint disable*/}
                {/*{React.isValidElement(loyaltyDiscountElement) && loyaltyDiscountElement}*/}

                <Box
                    mt={1}
                    px={2}
                >
                    <Typography variant="body2">
                        {totalDescription}
                    </Typography>
                </Box>
            </Box>

        </Box>
    );
};

PriceCostList.propTypes = {
    items: PropTypes.array,
    currency: PropTypes.string,
    total: PropTypes.number,
    totalDescription: PropTypes.string,
    originalTotal: PropTypes.number,
    inDirectSalesOrderView: PropTypes.bool,
    pointsPromotionElement: PropTypes.element,
    loyaltyDiscountElement: PropTypes.element
};

export default PriceCostList;
